import * as React from 'react';
import { MediaPreviewComponent } from '../components/media';

// Componente de teste para verificar se o preview mobile funciona corretamente
const TestMobilePreviewExample: React.FC = () => {
  const [file, setFile] = React.useState<any>(null);
  const [submitCount, setSubmitCount] = React.useState(0);

  // Simula upload de arquivo
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('📂 Arquivo selecionado:', event.target.files?.[0]);
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newFile = {
          preview: e.target?.result as string,
          uri: e.target?.result as string,
          path: selectedFile.name,
          size: selectedFile.size,
          type: selectedFile.type,
          name: selectedFile.name
        };
        console.log('📸 Arquivo processado:', newFile);
        setFile(newFile);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitCount(prev => prev + 1);
    console.log('📤 Formulário submetido!', { submitCount: submitCount + 1 });
    alert(`Formulário submetido ${submitCount + 1} vez(es)! O botão de preview NÃO deveria causar isso.`);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🧪 Teste: Preview Mobile (Sem Submit)</h1>
      
      <div style={{ 
        padding: '15px', 
        backgroundColor: submitCount > 0 ? '#ffebee' : '#e8f5e8',
        borderRadius: '8px',
        marginBottom: '20px',
        border: `2px solid ${submitCount > 0 ? '#f44336' : '#4caf50'}`
      }}>
        <h3>📊 Status do Teste:</h3>
        <p><strong>Submits do formulário:</strong> {submitCount}</p>
        <p style={{ color: submitCount > 0 ? '#d32f2f' : '#388e3c' }}>
          {submitCount === 0 ? '✅ Perfeito! Nenhum submit indevido.' : '❌ PROBLEMA: Botão está submetendo o formulário!'}
        </p>
      </div>

      <form onSubmit={handleFormSubmit} style={{ 
        border: '1px solid #ddd', 
        borderRadius: '8px', 
        padding: '20px',
        backgroundColor: '#fafafa'
      }}>
        <h3>📝 Formulário de Teste</h3>
        
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="file-input" style={{
            display: 'inline-block',
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
            Selecionar Imagem
          </label>
          <input 
            id="file-input"
            type="file" 
            accept="image/*" 
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
        </div>

        {file && (
          <div style={{ 
            border: '1px solid #ccc', 
            borderRadius: '8px', 
            padding: '15px',
            backgroundColor: 'white'
          }}>
            <h4>Preview da Imagem:</h4>
            <MediaPreviewComponent
              file={file}
              mediaType="image"
              removeAll={() => setFile(null)}
              isUploading={false}
              uploadProgress={0}
              title="Curso de Teste"
              description="Este é um teste para verificar se o preview mobile funciona sem submeter o formulário"
            />
          </div>
        )}

        <div style={{ marginTop: '20px' }}>
          <button 
            type="submit" 
            style={{ 
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Submeter Formulário (ESTE sim deve submeter)
          </button>
        </div>
      </form>

      {!file && (
        <div style={{
          border: '2px dashed #ddd',
          borderRadius: '8px',
          padding: '40px',
          textAlign: 'center',
          color: '#666',
          marginTop: '20px'
        }}>
          <p>👆 Selecione uma imagem para testar o preview mobile!</p>
          <p><small>O botão "Ver Preview Mobile" NÃO deve submeter o formulário</small></p>
        </div>
      )}
    </div>
  );
};

export default TestMobilePreviewExample;
